<footer class="container-fluid bg-light text-center ">
  <p><a href="http://www.fondation.org.ma" target="_blank"></a>{{ 'fras' | translate }} - ,{{ 'casablanca' | translate }} {{ year }} ©</p>
</footer>